import React from 'react';

/**
 * Consistent section title row (heading + optional action slot).
 */
export default function SectionHeader({ title, children, className = '' }) {
  return (
    <div className={`section-header ${className}`.trim()}>
      <h2 className="section-title">{title}</h2>
      {children}
    </div>
  );
}
